var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-advanced-group',{attrs:{"title":"Mechanics","count":_vm.count}},[_c('core-filter-input-suggest',{attrs:{"placeholder":"Start typing a mechanic...","has-require":true,"toggle":true,"field":"mechanic_name","filter":_vm.value('mechanics'),"api":"mechanics/suggest","data":"mechanics"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }